import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import css from './OrderBreakdown.module.css';

/**
 * A component that renders the selected variant info as a line item.
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.lineItem>} props.lineItems - The line items to render
 * @returns {JSX.Element}
 */
const LineItemVariantMaybe = props => {
  const { lineItems } = props;
  
  // Find the unit line item that has variant info
  const unitLineItem = lineItems.find(item => item.variantName && !item.reversal);
  
  if (!unitLineItem || !unitLineItem.variantName) {
    return null;
  }

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage 
          id="OrderBreakdown.variantName" 
          defaultMessage="Variant: {variantName}"
          values={{ variantName: unitLineItem.variantName }}
        />
      </span>
    </div>
  );
};

export default LineItemVariantMaybe;
